export default "__VITE_ASSET__CNDGYPg5__"